<template lang="pug">
.sv-select-list
    .sv-select-list__container(
        v-for="(value, index) in actualOnly"
        :key="value"
    )
        SvSelect(
            view="white"
            :value="value"
            :items="items"
            :withSearch="withSearch"
            :disabledValues="duplicateItems"
            :class="{ 'sv-select-list--with-remove': value !== null }"
            @input="(id) => changeValue(id, index)"
        )

        SvButton.sv-select-list__icon(
            v-if="value !== null"
            icon
            :prependIcon=`{
                icon: 'trash',
                width: 20,
                height: 20,
                default: '#B7BAC6',
                hover: '#1993EB'
            }`
            view="primary-icon"
            @click="removeItem(value, index)"
        )
</template>

<script>
import SvButton from '@/components/uikit/SvButton.vue';
import SvIcon from '@/components/uikit/SvIcon.vue';
import SvSelect from '@/components/uikit/SvSelect.vue';

export default {
  name: 'SvSelectList',

  model: {
    prop: 'values',
    event: 'change',
  },

  components: {
    SvIcon,
    SvSelect,
    SvButton,
  },

  props: {
    // Выбранные значения селектов
    values: {
      type: Array,
      default: () => [],
    },

    // Список значения для выбора
    items: {
      type: Array,
      required: true,
    },
    withSearch: {
      type: Boolean,
      default: false,
    },
  },
  updated() {
  },

  computed: {
    actualOnly() {
      // null значение может быть только одно и находится в конце
      return [...this.values.filter(v => v !== null), null];
    },

    duplicateItems() {
      return this.items.filter(item => this.values.find(v => v === item.id));
    },
  },

  methods: {
    changeValue(id, index) {
      const tempArray = [...this.values];
      tempArray.splice(index, 1, id);
      this.$emit('change', tempArray);
    },

    removeItem(id, index) {
      const tempArray = [...this.values];
      tempArray.splice(index, 1);
      this.$emit('change', tempArray);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-select-list__container {
    display: flex;
}

.sv-select-list--with-remove {
    margin-right: 10px;
    margin-bottom: 15px;
}

.sv-select-list__icon {
    margin-right: -50px;
}
</style>
